import { useRef, useState } from 'react'

import { useClipboard } from 'use-clipboard-copy'

import { SvgIcon } from '../../Icon/SvgIcon.js'

import { ActionAddon, ActionAddonProps } from './ActionAddon.js'

interface Props extends Omit<ActionAddonProps, 'label' | 'children'> {
  label?: string | ((isCopied: boolean) => string)
  value?: string | ReadonlyArray<string> | number | undefined
}

export function CopyAddon({ label, value, ...props }: Props) {
  const [copied, setCopied] = useState(false)
  const clipboard = useClipboard()

  const timeoutHandle = useRef<NodeJS.Timeout>(null)

  const onCopy = () => {
    clipboard.copy(value)
    setCopied(true)
    clearTimeout(timeoutHandle.current)
    timeoutHandle.current = setTimeout(() => setCopied(false), 2000)
  }

  return (
    <ActionAddon
      label={typeof label === 'function' ? label(copied) : label}
      onClick={onCopy}
      {...props}
    >
      <SvgIcon name={copied ? 'check' : 'copy'} size="lg" />
    </ActionAddon>
  )
}
